import { FormActivity } from './form-activity';
import { InspectionActivityModel } from './inspection-request-activity';

export class InspectionScheduleActivity extends FormActivity {
  inspectionId: string;
  time: any;
  model: InspectionActivityModel;
  canCancelInspection: boolean;
  canBypassInspection: boolean;

  constructor(options?: Partial<InspectionScheduleActivity>) {
    super(options);
    if (options) {
      Object.assign(this, options);
    }

    this.model = new InspectionActivityModel(options ? options.model : null);
  }
}
